import React from "react";
import { Table, Pagination } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import Loader from "components/Loader";
import { INVOICE_STATUS } from "common/constants";

export const SalaryList = ({
  Salaries,
  t,
  setShow,
  promiseState,
  items,
  activePagination,
  pageCount,
}) => {
  return (
    <>
      {promiseState?.pending && <Loader />}
      <div className="table-div">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="invoice_tabeletext">{t("Serial No.")}</th>
              <th className="invoice_tabeletext">{t("Customer")}</th>
              <th className="invoice_tabeletext">{t("Created")}</th>
              <th className="invoice_tabeletext">{t("Salary Type")}</th>
              <th className="invoice_tabeletext">{t("Invoice No")}</th>
              <th className="invoice_tabeletext">{t("Holiday Payout No.")}</th>
              <th className="invoice_tabeletext">{t("Amount")}</th>
              <th className="invoice_tabeletext">{t("Invoice Status")}</th>
              <th className="invoice_tabeletext">{t("Salary Status")}</th>
              <th className="invoice_tabeletext text-center">{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
            {Salaries?.map((cell, index) => {
              const serialNumber =
                (activePagination - 1) * pageCount + index + 1;
              return (
                <tr key={index}>
                  <td>{serialNumber}</td>
                  <td>
                    {cell?.signUpUser?.firstName +
                      " " +
                      cell?.signUpUser?.lastName}
                  </td>
                  <td>{cell?.createdDate.split("T")[0]}</td>
                  <td>
                    {cell?.salaryType === 1
                      ? t("Invoice")
                      : cell?.salaryType === 2
                      ? t("Holiday Payout")
                      : t("Manual Salary")}
                  </td>
                  <td>{cell?.invoice?.invoiceNumber || "-"}</td>
                  <td>{cell?.holidayPayoutId || "-"}</td>

                  <td>{cell?.amount}</td>
                  <td>
                    {cell?.salaryType === 2
                      ? "-"
                      : cell?.invoice?.invoiceStatus === INVOICE_STATUS.UNPAID
                      ? t("Unpaid")
                      : cell?.invoice?.invoiceStatus === INVOICE_STATUS.PAID
                      ? t("Paid")
                      : t("Partial")}
                  </td>
                  <td>{cell?.paid === true ? t("Paid") : t("Unpaid")}</td>

                  <td className="d-flex justify-content-center align-items-center height">
                    <div className="hover-text">
                      <button
                        id="top"
                        className="salary_view"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t("View")}
                        onClick={() =>
                          setShow({
                            viewDetails: true,
                            id:
                              cell?.salaryType === 1
                                ? cell?.invoice?.invoiceNumber
                                : cell?.salaryType === 2
                                ? cell?.holidayPayoutId
                                : cell?.employeeSalarysId,
                            salaryType: cell?.salaryType,
                          })
                        }
                      >
                        <FaEye size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {promiseState?.pending ? null : Salaries?.length === 0 &&
          promiseState?.fulfilled ? (
          <div className="text-center">
            <h2>{t("No data found")}</h2>
          </div>
        ) : promiseState?.rejected ? (
          <div className="text-center">
            <h2>{t("Found an error please try again within few minutes")}</h2>
          </div>
        ) : (
          ""
        )}

        <div className="paginationInvoice">
          <Pagination style={{ flexWrap: "wrap" }}>{items}</Pagination>
          <br />
        </div>
      </div>
    </>
  );
};
